import React from 'react';

type Props = {
  condition?: any;
  children: React.ReactNode;
  elseContent?: React.ReactNode;
}

export const ConditionalWrapper: React.FC<Props> = ({ condition, children, elseContent }) => {
  if (condition) return <>{children}</>;
  return <>{elseContent ?? children}</>;
}

export default ConditionalWrapper;
